import BigNumber from 'bignumber.js';
export var formatAmount = function formatAmount(amount) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
  return new BigNumber(amount).toFormat(decimals).replace(/\.?0+$/, '');
};